module.exports = __webpack_public_path__ + "img/commander3.png";